export const TRANSITION_DURATIONS = {
  // Простые fade анимации
  FADE: 400,

  // Page transition
  PAGE_TRANSFORM: 800,
}

export const DEFAULT_STEP_DELAY = 200
export const DEFAULT_STEP_COUNT = 1

export const OFFSET_DESKTOP = 64
export const OFFSET_MOBILE = 40



// WEBPACK FOOTER //
// ./src/modules/shared/const/animation.const.js